module.exports = __webpack_public_path__ + "static/media/back-arrow.0949a6d4.svg";